//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DialogsAdeInstitucionalniPredpokladPovolenyTypDokumentu.ts						</Name>
//    <Description> Funkce pro otev�en� dialog� spojen�ch s Povolen� typy pro institucion�ln� p�edpoklad </Description>
//    <Author>      JKLUSACEK													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-10-25                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(srvvtyp) GID:(Web.Dia.Ts) V1:(ixs_typ,ixs_tip,aktivita,dat_zmena,zmenu_prov) V2:() K1:() K2:() K3:() ]

namespace Gordic.Adm.Dialogs {

    // AdeInstitucionalniPredpokladPovolenyTypDokumentu
    export function DetailAdeInstitucionalniPredpokladPovolenyTypDokumentuDlg(
        parentContent: GContent,
        opt: {
            /** ixs_typ */
            ixs_typ: string | null,
            /** ixs_tip */
            ixs_tip: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** p��znak nov�ho z�znamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;
    var detailCommand = opt.grid ? false : true;

    // grid remote control, kv�li �ipk�m na detailu
    const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

    var detail = ['Gordic.Adm.WebControls.DetailAdeInstitucionalniPredpokladPovolenyTypDokumentu', { gridRemoteControl: gridRemoteControl }]

    const options = {
        ID: "AdmAdeInstitucionalniPredpokladPovolenyTypDokumentu#",
        ixs_typ: opt ? opt.ixs_typ : undefined,
        ixs_tip: opt ? opt.ixs_tip : undefined,
        newRecord: opt ? opt.newRecord : undefined,
        detailCommand: detailCommand
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
}

    // AdeInstitucionalniPredpokladPovolenyTypDokumentu
    export function SeznamAdeInstitucionalniPredpokladPovolenyTypDokumentuDlg(
        parentContent: GContent,
        opt: {
            /** ixs_typ */
            ixs_typ: string | null,
            /** ixs_tip */
            ixs_tip: string | null,
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;

    var detail = ['Gordic.Adm.WebControls.SeznamAdeInstitucionalniPredpokladPovolenyTypDokumentu', { }]

    const options = {
        ID: "AdmAdeInstitucionalniPredpokladPovolenyTypDokumentu#",
        ixs_typ: opt ? opt.ixs_typ : undefined,
        ixs_tip: opt ? opt.ixs_tip : undefined,
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
  }

}
